<template>
  <div class="app-wrap">
    <div v-if="isMain" :span="24" class="padding24 h100 overflow-x-y">
      <!-- 搜索框 start-->
      <div class="search" style="height: 60px">
        <el-form :inline="true" :model="searchForm" class="demo-form-inline" @submit.native.prevent>
          <!-- 操作人或模块名称搜索条件 start -->
          <el-form-item label="">
            <el-input
              v-model.trim="searchForm.value"
              clearable
              style="width: 316px"
              :placeholder="$t('code.pleaseEnterCodeOrCodeName')"
              @keyup.enter.native="handleSearch"
            >
              <i
                slot="suffix"
                class="el-input__icon el-icon-search cursor-p"
                @click="handleSearch"
              />
            </el-input>
          </el-form-item>
          <!-- 操作人或模块名称搜索条件 end -->
          <!-- 添加按钮 start -->
          <el-form-item class="float-right" style="margin-right: 0">
            <el-button
              v-if="visibleResource('sys_code_list_button_add')"
              icon="el-icon-circle-plus-outline"
              type="primary"
              @click="
                handleCodeShow({
                  type: 'add',
                  data: null
                })
              "
            >
              {{ getLabel('sys_code_list_button_add') }}
            </el-button>
          </el-form-item>
          <!-- 添加按钮 end -->
        </el-form>
      </div>
      <!-- 搜索框 end-->
      <!-- 表格 start-->
      <CustomTable
        ref="customTable"
        :loading="loading"
        :table-data="tableData"
        :pagination="pagination"
        @handleSizeChange="handlePaginationChange"
        @handleCurrentChange="handlePaginationChange"
      >
        <el-table-column
          prop="code"
          label="编码代码"
        />
        <el-table-column
          prop="name"
          label="编码名称"
        />
        <el-table-column
          prop="style"
          label="编码值示例"
        ></el-table-column>
        <el-table-column
          prop="tableName"
          label="绑定值"
        ></el-table-column>
        <el-table-column
          prop="columnName"
          label="绑定字段"
        />
        <el-table-column
          :label="$t('public.operation')"
          width="100"
        >
          <template slot-scope="scope">
            <el-button
              v-if="visibleResource('sys_code_list_button_view')"
              class="cursor-p"
              type="text"
              @click="
                handleCodeShow({
                  type: 'view',
                  data: scope.row
                })
              "
            >
              {{ getLabel('sys_code_list_button_view') }}
            </el-button>
            <el-popover
              placement="bottom"
              trigger="hover"
              style="margin-left: 16px"
              class="cursor-p self-popover hover_popover"
              :visible-arrow="false"
            >
              <span slot="reference">
                <i class="el-icon-more" style="transform: rotate(90deg)" />
              </span>
              <div class="self-popover-items">
                <p class="self-popover-item font_14" @click="handleBatchCode(scope.row)">
                  批量生成编码
                </p>
                <p
                  v-if="visibleResource('sys_code_list_button_edit')"
                  class="self-popover-item text_detail"
                  @click="
                    handleCodeShow({
                      type: 'edit',
                      data: scope.row
                    })
                  "
                >
                  {{ getLabel('sys_code_list_button_edit') }}
                </p>
                <p
                  v-if="visibleResource('sys_code_list_button_delete')"
                  class="self-popover-item font_14"
                  style="color: red"
                  @click="handleDelete(scope.row)"
                >
                  {{ getLabel('sys_code_list_button_delete') }}
                </p>
              </div>
            </el-popover>
          </template>
        </el-table-column>
      </CustomTable>
      <!-- 表格 end-->
    </div>
    <add-and-edit v-else :type="codeType" :data-id="dataId" @back="isMain = true"></add-and-edit>
    <delete-dialog
      layout="left"
      :visible.sync="deleteDialogVisible"
      :content="deleteContent"
      :loading.sync="deleteLoading"
      @confirm="handleDeleteConfirm"
    />
    <batch-code-dialog
      :visible.sync="batchCodeDialogVisible"
      :code-data="currentRow"
    ></batch-code-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import DeleteDialog from "@/components/common/Dialogs/DeleteDialog";
import AddAndEdit from "./components/add-and-edit";
import BatchCodeDialog from "./components/batch-code-dialog";
import codeApi from "@/api/code/code";
import { schemaMixins } from "@/mixin/schema";

export default {
  name: "CodeList",
  components: {
    DeleteDialog,
    BatchCodeDialog,
    AddAndEdit
  },
  mixins: [schemaMixins],
  props: {
    isInit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      resourceCode: "code-list",
      isMain: true,
      codeType: "add",
      dataId: "",
      searchForm: {
        value: ""
      },
      loading: false,
      batchCodeDialogVisible: false,
      currentRow: {},
      pagination: {
        pageNum: 1,
        total: 0,
        pageSize: 10
      },
      tableData: [],
      deleteDialogVisible: false,
      deleteLoading: false,
      deleteContent: {
        title: this.$t("common.popupDelete.title"),
        description: this.$t("common.popupDelete.description")
      }
    };
  },
  computed: {
    ...mapGetters(["isSystem"])
  },
  watch: {
    $route(to, from) {
      if (to.path === "/code/code-list") {
        this.startSearch();
      }
    },
    "searchForm.value"(newVal, oldVal) {
      if (!newVal && oldVal) {
        this.startSearch();
      }
    }
  },
  created() {
    this.startSearch();
  },

  methods: {
    // 获取列表数据
    startSearch() {
      this.loading = true;
      const parmas = {
        query: {
          size: this.pagination.pageSize,
          page: this.pagination.pageNum,
          "orders[0].asc": "false",
          "orders[0].column": "createTime"
        },
        body: {
          search: this.searchForm.value
        }
      };
      codeApi.getList(parmas).then(res => {
        this.loading = false;
        const { data } = res;
        if (data) {
          const { records = [], total = 0 } = data;
          this.tableData = records;
          this.pagination.total = Number(total);
        }
      });
    },

    // 批量生成code弹框
    handleBatchCode(data) {
      this.currentRow = data;
      this.batchCodeDialogVisible = true;
    },

    handleCodeShow(data) {
      const rowData = data.data;
      this.codeType = data.type;
      this.dataId = rowData === null ? "null" : window.btoa(rowData.id);
      this.isMain = false;
    },
    // 数据删除包含级联子项删除
    handleDelete(row) {
      this.deleteId = row.id;
      this.deleteLoading = false;
      this.deleteDialogVisible = true;
    },

    // 确认删除
    handleDeleteConfirm() {
      this.deleteLoading = true;
      codeApi.deleteByIds([this.deleteId]).then(res => {
        // 从列表删除数据
        this.deleteDialogVisible = false;
        this.deleteLoading = false;
        this.$message.closeAll();
        this.$message.success(this.$t("dict.deleteSuccess"));
        this.startSearch();
      });
    },
    // 搜索
    handleSearch() {
      this.pagination.pageNum = 1;
      this.startSearch();
    },
    // 条数改变|页数改变
    handlePaginationChange(data) {
      this.$set(this, "pagination", data);
      this.startSearch();
    },
    // 页数改变
    handleCurrentChange(val) {
      this.current = val;
      this.startSearch();
    },
    handleUpdateList() {
      this.startSearch();
    }
  }
};
</script>

<style scoped>
.padding24 {
  padding: 24px;
}
.colorRed {
  color: red;
}
.el-tag {
  height: 23px;
  line-height: 23px;
}
</style>
